import { createContext, useContext, useRef, useState } from 'react';

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  
  const showLoader = () => {
    setIsLoading(true);
  };

  const hideLoader = () => {
    setIsLoading(false);
  };

  return (
    <LoadingContext.Provider value={{ isLoading, showLoader, hideLoader }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = (initialValue) => {
  const context = useContext(LoadingContext);
  const hasInitialized = useRef(false); 

  if (!hasInitialized.current && typeof initialValue === 'boolean') {
    hasInitialized.current = true;
    initialValue ? context.showLoader() : context.hideLoader();
  }

  const controller = (value) => {
    if (value === true) context.showLoader();
    else if (value === false) context.hideLoader();
  };

  controller.isLoading = context.isLoading;
  controller.showLoader = context.showLoader;
  controller.hideLoader = context.hideLoader;

  return controller;
};